@file:OptIn(InternalResourceApi::class)

package advancedmpkeditor.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/advancedmpkeditor.composeapp.generated.resources/"

@delegate:ResourceContentHash(641_088_496)
internal val Res.drawable.gray_wool: DrawableResource by lazy {
      DrawableResource("drawable:gray_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/gray_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_511_123_243)
internal val Res.drawable.green_banner: DrawableResource by lazy {
      DrawableResource("drawable:green_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_237_919_162)
internal val Res.drawable.green_bed: DrawableResource by lazy {
      DrawableResource("drawable:green_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(100_003_415)
internal val Res.drawable.green_carpet: DrawableResource by lazy {
      DrawableResource("drawable:green_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_carpet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-411_218_018)
internal val Res.drawable.green_concrete: DrawableResource by lazy {
      DrawableResource("drawable:green_concrete", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_concrete.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-764_469_205)
internal val Res.drawable.green_concrete_powder: DrawableResource by lazy {
      DrawableResource("drawable:green_concrete_powder", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_concrete_powder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_874_091_646)
internal val Res.drawable.green_dye: DrawableResource by lazy {
      DrawableResource("drawable:green_dye", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_dye.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_079_301_750)
internal val Res.drawable.green_glazed_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:green_glazed_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_glazed_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(210_043_611)
internal val Res.drawable.green_shulker_box: DrawableResource by lazy {
      DrawableResource("drawable:green_shulker_box", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_shulker_box.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_669_260_990)
internal val Res.drawable.green_stained_glass: DrawableResource by lazy {
      DrawableResource("drawable:green_stained_glass", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_stained_glass.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_764_231_031)
internal val Res.drawable.green_stained_glass_pane: DrawableResource by lazy {
      DrawableResource("drawable:green_stained_glass_pane", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_stained_glass_pane.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_134_673_086)
internal val Res.drawable.green_terracotta: DrawableResource by lazy {
      DrawableResource("drawable:green_terracotta", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_terracotta.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_851_188_863)
internal val Res.drawable.green_wool: DrawableResource by lazy {
      DrawableResource("drawable:green_wool", setOf(
        ResourceItem(setOf(), "${MD}drawable/green_wool.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_172_468_294)
internal val Res.drawable.grindstone: DrawableResource by lazy {
      DrawableResource("drawable:grindstone", setOf(
        ResourceItem(setOf(), "${MD}drawable/grindstone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(249_089_361)
internal val Res.drawable.guardian_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:guardian_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/guardian_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_495_365_634)
internal val Res.drawable.gunpowder: DrawableResource by lazy {
      DrawableResource("drawable:gunpowder", setOf(
        ResourceItem(setOf(), "${MD}drawable/gunpowder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_025_897_113)
internal val Res.drawable.hay_block: DrawableResource by lazy {
      DrawableResource("drawable:hay_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/hay_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_813_401)
internal val Res.drawable.heart_of_the_sea: DrawableResource by lazy {
      DrawableResource("drawable:heart_of_the_sea", setOf(
        ResourceItem(setOf(), "${MD}drawable/heart_of_the_sea.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_595_062_824)
internal val Res.drawable.heavy_weighted_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:heavy_weighted_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/heavy_weighted_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_099_584_072)
internal val Res.drawable.hoglin_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:hoglin_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/hoglin_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_050_135_500)
internal val Res.drawable.honey_block: DrawableResource by lazy {
      DrawableResource("drawable:honey_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/honey_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_526_062_364)
internal val Res.drawable.honey_bottle: DrawableResource by lazy {
      DrawableResource("drawable:honey_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/honey_bottle.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-244_190_192)
internal val Res.drawable.honeycomb: DrawableResource by lazy {
      DrawableResource("drawable:honeycomb", setOf(
        ResourceItem(setOf(), "${MD}drawable/honeycomb.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_026_263_022)
internal val Res.drawable.honeycomb_block: DrawableResource by lazy {
      DrawableResource("drawable:honeycomb_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/honeycomb_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_826_784_952)
internal val Res.drawable.hopper: DrawableResource by lazy {
      DrawableResource("drawable:hopper", setOf(
        ResourceItem(setOf(), "${MD}drawable/hopper.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_961_459_824)
internal val Res.drawable.hopper_minecart: DrawableResource by lazy {
      DrawableResource("drawable:hopper_minecart", setOf(
        ResourceItem(setOf(), "${MD}drawable/hopper_minecart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-282_297_339)
internal val Res.drawable.horn_coral: DrawableResource by lazy {
      DrawableResource("drawable:horn_coral", setOf(
        ResourceItem(setOf(), "${MD}drawable/horn_coral.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_928_543_592)
internal val Res.drawable.horn_coral_block: DrawableResource by lazy {
      DrawableResource("drawable:horn_coral_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/horn_coral_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-521_363_724)
internal val Res.drawable.horn_coral_fan: DrawableResource by lazy {
      DrawableResource("drawable:horn_coral_fan", setOf(
        ResourceItem(setOf(), "${MD}drawable/horn_coral_fan.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_012_919_768)
internal val Res.drawable.horse_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:horse_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/horse_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(173_397_352)
internal val Res.drawable.husk_spawn_egg: DrawableResource by lazy {
      DrawableResource("drawable:husk_spawn_egg", setOf(
        ResourceItem(setOf(), "${MD}drawable/husk_spawn_egg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_461_916_182)
internal val Res.drawable.ice: DrawableResource by lazy {
      DrawableResource("drawable:ice", setOf(
        ResourceItem(setOf(), "${MD}drawable/ice.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-300_166_474)
internal val Res.drawable.infested_chiseled_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:infested_chiseled_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_chiseled_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(257_538_547)
internal val Res.drawable.infested_cobblestone: DrawableResource by lazy {
      DrawableResource("drawable:infested_cobblestone", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_cobblestone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-465_645_409)
internal val Res.drawable.infested_cracked_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:infested_cracked_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_cracked_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-208_376_425)
internal val Res.drawable.infested_mossy_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:infested_mossy_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_mossy_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(14_633_294)
internal val Res.drawable.infested_stone: DrawableResource by lazy {
      DrawableResource("drawable:infested_stone", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_stone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(715_264_633)
internal val Res.drawable.infested_stone_bricks: DrawableResource by lazy {
      DrawableResource("drawable:infested_stone_bricks", setOf(
        ResourceItem(setOf(), "${MD}drawable/infested_stone_bricks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-88_977_062)
internal val Res.drawable.ink_sac: DrawableResource by lazy {
      DrawableResource("drawable:ink_sac", setOf(
        ResourceItem(setOf(), "${MD}drawable/ink_sac.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_722_917_479)
internal val Res.drawable.iron_axe: DrawableResource by lazy {
      DrawableResource("drawable:iron_axe", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_axe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_194_266_387)
internal val Res.drawable.iron_bars: DrawableResource by lazy {
      DrawableResource("drawable:iron_bars", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_bars.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_412_090_522)
internal val Res.drawable.iron_block: DrawableResource by lazy {
      DrawableResource("drawable:iron_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-39_756_298)
internal val Res.drawable.iron_boots: DrawableResource by lazy {
      DrawableResource("drawable:iron_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-115_127_541)
internal val Res.drawable.iron_boots_ss1: DrawableResource by lazy {
      DrawableResource("drawable:iron_boots_ss1", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_boots_ss1.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-622_359_307)
internal val Res.drawable.iron_boots_ss2: DrawableResource by lazy {
      DrawableResource("drawable:iron_boots_ss2", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_boots_ss2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_282_858_355)
internal val Res.drawable.iron_boots_ss3: DrawableResource by lazy {
      DrawableResource("drawable:iron_boots_ss3", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_boots_ss3.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_399_336_318)
internal val Res.drawable.iron_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:iron_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_798_213_364)
internal val Res.drawable.iron_door: DrawableResource by lazy {
      DrawableResource("drawable:iron_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_546_170_961)
internal val Res.drawable.iron_helmet: DrawableResource by lazy {
      DrawableResource("drawable:iron_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(819_632_540)
internal val Res.drawable.iron_hoe: DrawableResource by lazy {
      DrawableResource("drawable:iron_hoe", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_hoe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_511_685_050)
internal val Res.drawable.iron_horse_armor: DrawableResource by lazy {
      DrawableResource("drawable:iron_horse_armor", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_horse_armor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(920_747_635)
internal val Res.drawable.iron_ingot: DrawableResource by lazy {
      DrawableResource("drawable:iron_ingot", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_ingot.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_888_946_785)
internal val Res.drawable.iron_leggings: DrawableResource by lazy {
      DrawableResource("drawable:iron_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_732_664_787)
internal val Res.drawable.iron_nugget: DrawableResource by lazy {
      DrawableResource("drawable:iron_nugget", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_nugget.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_559_951_824)
internal val Res.drawable.iron_ore: DrawableResource by lazy {
      DrawableResource("drawable:iron_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_579_887_052)
internal val Res.drawable.iron_pickaxe: DrawableResource by lazy {
      DrawableResource("drawable:iron_pickaxe", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_pickaxe.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(137_399_420)
internal val Res.drawable.iron_shovel: DrawableResource by lazy {
      DrawableResource("drawable:iron_shovel", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_shovel.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(883_378_544)
internal val Res.drawable.iron_sword: DrawableResource by lazy {
      DrawableResource("drawable:iron_sword", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_sword.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_847_219_612)
internal val Res.drawable.iron_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:iron_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/iron_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-384_098_527)
internal val Res.drawable.item_frame: DrawableResource by lazy {
      DrawableResource("drawable:item_frame", setOf(
        ResourceItem(setOf(), "${MD}drawable/item_frame.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(862_381_973)
internal val Res.drawable.jack_o_lantern: DrawableResource by lazy {
      DrawableResource("drawable:jack_o_lantern", setOf(
        ResourceItem(setOf(), "${MD}drawable/jack_o_lantern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_829_051_412)
internal val Res.drawable.jigsaw: DrawableResource by lazy {
      DrawableResource("drawable:jigsaw", setOf(
        ResourceItem(setOf(), "${MD}drawable/jigsaw.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-686_272_502)
internal val Res.drawable.jukebox: DrawableResource by lazy {
      DrawableResource("drawable:jukebox", setOf(
        ResourceItem(setOf(), "${MD}drawable/jukebox.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(721_607_318)
internal val Res.drawable.jungle_boat: DrawableResource by lazy {
      DrawableResource("drawable:jungle_boat", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_boat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_822_937_665)
internal val Res.drawable.jungle_button: DrawableResource by lazy {
      DrawableResource("drawable:jungle_button", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_button.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-168_235_629)
internal val Res.drawable.jungle_door: DrawableResource by lazy {
      DrawableResource("drawable:jungle_door", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_door.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_067_175_178)
internal val Res.drawable.jungle_fence: DrawableResource by lazy {
      DrawableResource("drawable:jungle_fence", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_fence.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(998_483_615)
internal val Res.drawable.jungle_fence_gate: DrawableResource by lazy {
      DrawableResource("drawable:jungle_fence_gate", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_fence_gate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_993_954_307)
internal val Res.drawable.jungle_leaves: DrawableResource by lazy {
      DrawableResource("drawable:jungle_leaves", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_leaves.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_017_117_327)
internal val Res.drawable.jungle_log: DrawableResource by lazy {
      DrawableResource("drawable:jungle_log", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_log.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-596_065_315)
internal val Res.drawable.jungle_planks: DrawableResource by lazy {
      DrawableResource("drawable:jungle_planks", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_planks.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_570_494_388)
internal val Res.drawable.jungle_pressure_plate: DrawableResource by lazy {
      DrawableResource("drawable:jungle_pressure_plate", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_pressure_plate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_554_161_107)
internal val Res.drawable.jungle_sapling: DrawableResource by lazy {
      DrawableResource("drawable:jungle_sapling", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_sapling.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-382_993_259)
internal val Res.drawable.jungle_sign: DrawableResource by lazy {
      DrawableResource("drawable:jungle_sign", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_sign.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_659_311_280)
internal val Res.drawable.jungle_slab: DrawableResource by lazy {
      DrawableResource("drawable:jungle_slab", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_slab.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(647_751_263)
internal val Res.drawable.jungle_stairs: DrawableResource by lazy {
      DrawableResource("drawable:jungle_stairs", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_stairs.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-431_177_971)
internal val Res.drawable.jungle_trapdoor: DrawableResource by lazy {
      DrawableResource("drawable:jungle_trapdoor", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_trapdoor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-634_038_163)
internal val Res.drawable.jungle_wood: DrawableResource by lazy {
      DrawableResource("drawable:jungle_wood", setOf(
        ResourceItem(setOf(), "${MD}drawable/jungle_wood.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-630_357_691)
internal val Res.drawable.kelp: DrawableResource by lazy {
      DrawableResource("drawable:kelp", setOf(
        ResourceItem(setOf(), "${MD}drawable/kelp.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-952_107_846)
internal val Res.drawable.kill_zombie_pigs_potion: DrawableResource by lazy {
      DrawableResource("drawable:kill_zombie_pigs_potion", setOf(
        ResourceItem(setOf(), "${MD}drawable/kill_zombie_pigs_potion.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(880_574_116)
internal val Res.drawable.knowledge_book: DrawableResource by lazy {
      DrawableResource("drawable:knowledge_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/knowledge_book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-635_518_862)
internal val Res.drawable.ladder: DrawableResource by lazy {
      DrawableResource("drawable:ladder", setOf(
        ResourceItem(setOf(), "${MD}drawable/ladder.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-846_612_035)
internal val Res.drawable.lantern: DrawableResource by lazy {
      DrawableResource("drawable:lantern", setOf(
        ResourceItem(setOf(), "${MD}drawable/lantern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(455_795_094)
internal val Res.drawable.lapis_block: DrawableResource by lazy {
      DrawableResource("drawable:lapis_block", setOf(
        ResourceItem(setOf(), "${MD}drawable/lapis_block.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(386_460_092)
internal val Res.drawable.lapis_lazuli: DrawableResource by lazy {
      DrawableResource("drawable:lapis_lazuli", setOf(
        ResourceItem(setOf(), "${MD}drawable/lapis_lazuli.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_363_247_438)
internal val Res.drawable.lapis_ore: DrawableResource by lazy {
      DrawableResource("drawable:lapis_ore", setOf(
        ResourceItem(setOf(), "${MD}drawable/lapis_ore.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_680_504_782)
internal val Res.drawable.large_fern: DrawableResource by lazy {
      DrawableResource("drawable:large_fern", setOf(
        ResourceItem(setOf(), "${MD}drawable/large_fern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(4_232_011)
internal val Res.drawable.lava_bucket: DrawableResource by lazy {
      DrawableResource("drawable:lava_bucket", setOf(
        ResourceItem(setOf(), "${MD}drawable/lava_bucket.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-244_605_694)
internal val Res.drawable.lead: DrawableResource by lazy {
      DrawableResource("drawable:lead", setOf(
        ResourceItem(setOf(), "${MD}drawable/lead.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-141_549_498)
internal val Res.drawable.leather: DrawableResource by lazy {
      DrawableResource("drawable:leather", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_797_254_416)
internal val Res.drawable.leather_boots: DrawableResource by lazy {
      DrawableResource("drawable:leather_boots", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather_boots.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-931_011_958)
internal val Res.drawable.leather_chestplate: DrawableResource by lazy {
      DrawableResource("drawable:leather_chestplate", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather_chestplate.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_733_339_443)
internal val Res.drawable.leather_helmet: DrawableResource by lazy {
      DrawableResource("drawable:leather_helmet", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather_helmet.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_051_947_750)
internal val Res.drawable.leather_horse_armor: DrawableResource by lazy {
      DrawableResource("drawable:leather_horse_armor", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather_horse_armor.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-920_212_218)
internal val Res.drawable.leather_leggings: DrawableResource by lazy {
      DrawableResource("drawable:leather_leggings", setOf(
        ResourceItem(setOf(), "${MD}drawable/leather_leggings.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_015_396_900)
internal val Res.drawable.lectern: DrawableResource by lazy {
      DrawableResource("drawable:lectern", setOf(
        ResourceItem(setOf(), "${MD}drawable/lectern.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_833_682_396)
internal val Res.drawable.lever: DrawableResource by lazy {
      DrawableResource("drawable:lever", setOf(
        ResourceItem(setOf(), "${MD}drawable/lever.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_230_615_992)
internal val Res.drawable.light_blue_banner: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_banner", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_banner.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_373_764_207)
internal val Res.drawable.light_blue_bed: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_bed", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_bed.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-647_185_701)
internal val Res.drawable.light_blue_carpet: DrawableResource by lazy {
      DrawableResource("drawable:light_blue_carpet", setOf(
        ResourceItem(setOf(), "${MD}drawable/light_blue_carpet.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable4Resources(map: MutableMap<String, DrawableResource>) {
  map.put("gray_wool", Res.drawable.gray_wool)
  map.put("green_banner", Res.drawable.green_banner)
  map.put("green_bed", Res.drawable.green_bed)
  map.put("green_carpet", Res.drawable.green_carpet)
  map.put("green_concrete", Res.drawable.green_concrete)
  map.put("green_concrete_powder", Res.drawable.green_concrete_powder)
  map.put("green_dye", Res.drawable.green_dye)
  map.put("green_glazed_terracotta", Res.drawable.green_glazed_terracotta)
  map.put("green_shulker_box", Res.drawable.green_shulker_box)
  map.put("green_stained_glass", Res.drawable.green_stained_glass)
  map.put("green_stained_glass_pane", Res.drawable.green_stained_glass_pane)
  map.put("green_terracotta", Res.drawable.green_terracotta)
  map.put("green_wool", Res.drawable.green_wool)
  map.put("grindstone", Res.drawable.grindstone)
  map.put("guardian_spawn_egg", Res.drawable.guardian_spawn_egg)
  map.put("gunpowder", Res.drawable.gunpowder)
  map.put("hay_block", Res.drawable.hay_block)
  map.put("heart_of_the_sea", Res.drawable.heart_of_the_sea)
  map.put("heavy_weighted_pressure_plate", Res.drawable.heavy_weighted_pressure_plate)
  map.put("hoglin_spawn_egg", Res.drawable.hoglin_spawn_egg)
  map.put("honey_block", Res.drawable.honey_block)
  map.put("honey_bottle", Res.drawable.honey_bottle)
  map.put("honeycomb", Res.drawable.honeycomb)
  map.put("honeycomb_block", Res.drawable.honeycomb_block)
  map.put("hopper", Res.drawable.hopper)
  map.put("hopper_minecart", Res.drawable.hopper_minecart)
  map.put("horn_coral", Res.drawable.horn_coral)
  map.put("horn_coral_block", Res.drawable.horn_coral_block)
  map.put("horn_coral_fan", Res.drawable.horn_coral_fan)
  map.put("horse_spawn_egg", Res.drawable.horse_spawn_egg)
  map.put("husk_spawn_egg", Res.drawable.husk_spawn_egg)
  map.put("ice", Res.drawable.ice)
  map.put("infested_chiseled_stone_bricks", Res.drawable.infested_chiseled_stone_bricks)
  map.put("infested_cobblestone", Res.drawable.infested_cobblestone)
  map.put("infested_cracked_stone_bricks", Res.drawable.infested_cracked_stone_bricks)
  map.put("infested_mossy_stone_bricks", Res.drawable.infested_mossy_stone_bricks)
  map.put("infested_stone", Res.drawable.infested_stone)
  map.put("infested_stone_bricks", Res.drawable.infested_stone_bricks)
  map.put("ink_sac", Res.drawable.ink_sac)
  map.put("iron_axe", Res.drawable.iron_axe)
  map.put("iron_bars", Res.drawable.iron_bars)
  map.put("iron_block", Res.drawable.iron_block)
  map.put("iron_boots", Res.drawable.iron_boots)
  map.put("iron_boots_ss1", Res.drawable.iron_boots_ss1)
  map.put("iron_boots_ss2", Res.drawable.iron_boots_ss2)
  map.put("iron_boots_ss3", Res.drawable.iron_boots_ss3)
  map.put("iron_chestplate", Res.drawable.iron_chestplate)
  map.put("iron_door", Res.drawable.iron_door)
  map.put("iron_helmet", Res.drawable.iron_helmet)
  map.put("iron_hoe", Res.drawable.iron_hoe)
  map.put("iron_horse_armor", Res.drawable.iron_horse_armor)
  map.put("iron_ingot", Res.drawable.iron_ingot)
  map.put("iron_leggings", Res.drawable.iron_leggings)
  map.put("iron_nugget", Res.drawable.iron_nugget)
  map.put("iron_ore", Res.drawable.iron_ore)
  map.put("iron_pickaxe", Res.drawable.iron_pickaxe)
  map.put("iron_shovel", Res.drawable.iron_shovel)
  map.put("iron_sword", Res.drawable.iron_sword)
  map.put("iron_trapdoor", Res.drawable.iron_trapdoor)
  map.put("item_frame", Res.drawable.item_frame)
  map.put("jack_o_lantern", Res.drawable.jack_o_lantern)
  map.put("jigsaw", Res.drawable.jigsaw)
  map.put("jukebox", Res.drawable.jukebox)
  map.put("jungle_boat", Res.drawable.jungle_boat)
  map.put("jungle_button", Res.drawable.jungle_button)
  map.put("jungle_door", Res.drawable.jungle_door)
  map.put("jungle_fence", Res.drawable.jungle_fence)
  map.put("jungle_fence_gate", Res.drawable.jungle_fence_gate)
  map.put("jungle_leaves", Res.drawable.jungle_leaves)
  map.put("jungle_log", Res.drawable.jungle_log)
  map.put("jungle_planks", Res.drawable.jungle_planks)
  map.put("jungle_pressure_plate", Res.drawable.jungle_pressure_plate)
  map.put("jungle_sapling", Res.drawable.jungle_sapling)
  map.put("jungle_sign", Res.drawable.jungle_sign)
  map.put("jungle_slab", Res.drawable.jungle_slab)
  map.put("jungle_stairs", Res.drawable.jungle_stairs)
  map.put("jungle_trapdoor", Res.drawable.jungle_trapdoor)
  map.put("jungle_wood", Res.drawable.jungle_wood)
  map.put("kelp", Res.drawable.kelp)
  map.put("kill_zombie_pigs_potion", Res.drawable.kill_zombie_pigs_potion)
  map.put("knowledge_book", Res.drawable.knowledge_book)
  map.put("ladder", Res.drawable.ladder)
  map.put("lantern", Res.drawable.lantern)
  map.put("lapis_block", Res.drawable.lapis_block)
  map.put("lapis_lazuli", Res.drawable.lapis_lazuli)
  map.put("lapis_ore", Res.drawable.lapis_ore)
  map.put("large_fern", Res.drawable.large_fern)
  map.put("lava_bucket", Res.drawable.lava_bucket)
  map.put("lead", Res.drawable.lead)
  map.put("leather", Res.drawable.leather)
  map.put("leather_boots", Res.drawable.leather_boots)
  map.put("leather_chestplate", Res.drawable.leather_chestplate)
  map.put("leather_helmet", Res.drawable.leather_helmet)
  map.put("leather_horse_armor", Res.drawable.leather_horse_armor)
  map.put("leather_leggings", Res.drawable.leather_leggings)
  map.put("lectern", Res.drawable.lectern)
  map.put("lever", Res.drawable.lever)
  map.put("light_blue_banner", Res.drawable.light_blue_banner)
  map.put("light_blue_bed", Res.drawable.light_blue_bed)
  map.put("light_blue_carpet", Res.drawable.light_blue_carpet)
}
